import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useWizard } from 'react-use-wizard'
import cx from 'classnames'
import { useState } from 'react'
import { PageTitle, Button, Modal } from 'web/src/app/root/components/common'
import { useBooleanState } from 'web/src/utils/hooks/useBooleanState'
import { internalUser } from '../../../icons'
import { useCreateUser } from '../../context/create-user-context'
import ExternalUser from '../../../icons/external-user'
import { USER_RELATIONS } from 'web/src/app/root/constants'
import { useSelector } from 'react-redux'
import { InfoIcon } from 'lucide-react'
import { NavLink } from 'react-router-dom'

export const UserRelation = () => {
    const { nextStep } = useWizard()

    const { setRelation, userRelation } = useCreateUser()
    const { locale, theme } = useSelector(state => state.main)
    const styles = useStyles()
    const [selectedRelation, setSelectedRelation] = useState(userRelation)
    const [isBillingNotificationOpen, setIsBillingNotificationOpen] = useState(
        false
    )
    const pristine = useBooleanState(true)

    const isValid = () => {
        return Boolean(selectedRelation)
    }

    const handleNextStep = () => {
        pristine.off()
        if (!isValid()) {
            return
        }
        if (selectedRelation === 'external') {
            setIsBillingNotificationOpen(true)
        } else {
            setRelation(selectedRelation)
            nextStep()
        }
    }

    const acceptExternalUsersBilling = () => {
        setIsBillingNotificationOpen(false)
        setRelation('external')
        nextStep()
    }

    const handleSelectRelations = role => {
        setSelectedRelation(role)
    }

    return (
        <div className={styles.root}>
            <div>
                <PageTitle
                    position={'center'}
                    title={locale.userManagement.userRalationStepTitle}
                />
                <div className={styles.rolesContainer}>
                    <Modal
                        size="lg"
                        className={styles.modal}
                        onClose={() => setIsBillingNotificationOpen(false)}
                        open={isBillingNotificationOpen}
                    >
                        <div
                            style={{
                                height: 90,
                                width: '100%',
                                padding: 20,
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <InfoIcon size={28} style={{ marginRight: 10 }} />
                            {locale.billing.externalUsersCreationNotice}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: 20
                            }}
                        >
                            <NavLink
                                className={styles.link}
                                target={'_blank'}
                                to={`/billing`}
                            >
                                {locale.billing.billingDashboard}
                            </NavLink>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Button onClick={acceptExternalUsersBilling}>
                                {locale.common.acceptTerms}
                            </Button>
                        </div>
                    </Modal>
                    {userRelationOptions.map(({ code, icon: Icon }) => (
                        <button
                            key={code}
                            onClick={() => handleSelectRelations(code)}
                            className={cx(styles.role, {
                                [styles.selected]: selectedRelation === code
                            })}
                        >
                            <div className={styles.row}>
                                <div className={styles.icon}>
                                    <Icon />
                                </div>
                                <div className={styles.roleDesc}>
                                    <h3>
                                        {
                                            locale.userManagement
                                                .userRalationOptionName[code]
                                        }
                                    </h3>
                                    <p>
                                        {
                                            locale.userManagement
                                                .userRalationOptionDescription[
                                                code
                                            ]
                                        }
                                    </p>
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
            <div className={styles.buttonsBlock}>
                <Button disabled={!selectedRelation} onClick={handleNextStep}>
                    {locale.userManagement.nextStep}
                </Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: 27
    },
    row: {
        display: 'flex',
        alignItems: 'center'
    },
    roleDesc: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column'
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        padding: '40px 94px 0'
    },
    buttonsBlock: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // marginTop: "auto",
        marginTop: 20,
        marginBottom: 46,
        '&& > :last-child': {
            marginLeft: 16
        }
    },
    selected: {
        outline: `1px solid black !important`
    },
    rolesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 170,
        justifyContent: 'center',
        position: 'relative'
    },
    role: {
        '&& h3': {
            margin: 0,
            fontSize: 18
        },
        '&& p': {
            fontSize: 15,
            textAlign: 'left'
        },
        '&&:hover': {
            transform: 'scale(1.03)',
            transition: 'transform 0.1s ease-out'
        },
        cursor: 'pointer',
        borderRadius: 5,
        margin: 10,
        padding: '37px 21px',
        minWidth: 150,
        width: '45%',
        maxWidth: 453,
        // height: 170,
        background: '#F9F9F9',
        border: 'none'
    },
    link: theme.link
}))

const userRelationOptions = [
    {
        code: USER_RELATIONS.internal,
        icon: internalUser
    },
    {
        code: USER_RELATIONS.external,
        icon: ExternalUser
    }
]
